<template>
  <div>
    <b-field label="Phone number">
      <div style="display: flex">
        <p style="padding: 0 5px">+66</p>
        <b-input
          :disabled="disable"
          style="width: 100%"
          size="is-small"
          v-model="phone"
          type="username"
          minlength="9"
          maxlength="9"
          required
          validation-message="กรอกเบอร์มือถือไม่ถูกต้อง"
        ></b-input>
      </div>
    </b-field>
    <b-field label="Name">
      <b-input
        :disabled="disable"
        size="is-small"
        v-model="name"
        required
        validation-message="ไม่สามารถเว้นว่างได้"
      ></b-input>
    </b-field>
    <b-field label="License plate">
      <b-input
        :disabled="disable"
        size="is-small"
        v-model="licenseplate"
        required
        validation-message="ไม่สามารถเว้นว่างได้"
      ></b-input>
    </b-field>
    <b-field label="Model car">
      <b-input
        :disabled="disable"
        size="is-small"
        v-model="modelCar"
        required
        validation-message="ไม่สามารถเว้นว่างได้"
      ></b-input>
    </b-field>
    <b-field
      label="Password"
      :message="[
        'Passwords must have at least 8 characters and contain at least two of the following: uppercase letters, lowercase letters, numbers, and symbols.',
      ]"
    >
      <b-input
        :disabled="disable"
        size="is-small"
        type="password"
        required
        :state="isPasswordVilid"
        v-model="password"
        password-reveal
        validation-message="ไม่สามารถเว้นว่างได้"
      ></b-input>
    </b-field>
    <div style="text-align: end">
      <b-button v-if="!disable" :loading="loading" @click="onCreateDriver" type="is-primary"
        >ลงทะเบียนคนขับ</b-button
      >
    </div>
  </div>
</template>

<script>
import { Auth } from "aws-amplify";
export default {
  props: ["disable", "localData"],
  data() {
    return {
      name: null,
      licenseplate: null,
      modelCar: null,
      password: null,
      phone: null,
      loading: false,
    };
  },
  watch: {
    localData() {
      console.log(this.localData);
      if (this.localData !== null) {
        this.name = this.localData.name;
        this.licenseplate = this.localData.licenseplate;
        this.modelCar = this.localData.model_car;
        this.phone = this.localData.phone_no;
        this.password = this.localData.password;
      } else {
        this.name = null;
        this.licenseplate = null;
        this.modelCar = null;
        this.phone = null;
        this.password = null;
      }
      console.log(this.phone);
    },
  },
  methods: {
    async onCreateDriver() {
      let isValid = true;
      if (this.phone && this.password && this.licenseplate && this.modelCar && this.name) {
        if (this.password) {
          isValid = this.isPasswordVilid(this.password);
          console.log("isPasswordVilid", isValid);
          if (!isValid) {
            this.showAlert(
              "การกำหนดรหัสผ่านผิด: Passwords must have at least 8 characters and contain at least two of the following: uppercase letters, lowercase letters, numbers, and symbols."
            );
          }
        }
        if (this.phone) {
          isValid = this.isPhoneNoVilid(this.phone);
          console.log("isPhoneNoVilid", isValid);
          if (isValid !== null) {
            console.log(isValid);
            this.showAlert(isValid);
          } else {
            isValid = true;
          }
        }
      } else {
        isValid = false;
        this.showAlert("ลงทะเบียนคนขับผิดพลาด: กรุณากรอกรายละเอียดให้ครบถ้วน");
      }
      console.log("onCreateDriver", isValid);
      if (isValid === true) {
        console.log("WORK!!");
        try {
          const response = await Auth.signUp({
            username: `+66${this.phone}`,
            password: this.password,
            attributes: {
              phone_number: `+66${this.phone}`, // optional - E.164 number convention
            },
          });
          console.log("onCreateDriver", response);
          const data = {
            id: response.userSub,
            name: this.name,
            licenseplate: this.licenseplate,
            model_car: this.modelCar,
            phone_no: `+66${this.phone}`,
            status: "OFFLINE",
            password: this.password,
          };
          this.$emit("success", data);
        } catch (error) {
          console.log(error);
          this.$buefy.notification.open({
            message: `ลงทะเบียนคนขับผิดพลาด: ${error.message}`,
            type: "is-danger",
            duration: 5000,
            queue: false,
          });
        }
        this.loading = false;
      }
    },
    isPasswordVilid(password) {
      //eslint-disable-next-line
      let regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\^$*.\[\]{}\(\)?\-“!@#%&\/,><\’:;|_~`])\S{8,99}$/;
      return regex.test(password);
    },
    isPhoneNoVilid(phone) {
      var reg = new RegExp("^\\d+$");
      console.log(reg.test(phone));
      if (phone.length !== 9) {
        return "เบอร์มือถือต้องมีทั้งหมด 9 ตัว";
      } else if (!reg.test(phone)) {
        return "เบอร์มือถือต้องประกอบไปด้วยตัวเลขเท่านั้น";
      } else {
        return null;
      }
    },
    showAlert(message) {
      this.$buefy.notification.open({
        message: message,
        type: "is-danger",
        duration: 5000,
        queue: false,
      });
    },
  },
};
</script>

<style>
</style>